module.exports = __webpack_public_path__ + "9bb208533e48365cc36de6a474bedc84.png";